export default "__VITE_ASSET__29f1d005__"